import { autoinject } from "aurelia-framework";

import { FetchClient } from "../common/fetch-client";

@autoinject()
export class OrganizationService {
    private _httpClient: FetchClient;
    private _agencyUrl: string = "/api/v1/agency";

    public constructor(httpClient: FetchClient) {
        this._httpClient = httpClient;
    }

    public async getTwoFAConfiguration(organizationId: string) {
        return await this._httpClient
            .build(`${this._agencyUrl}/${organizationId}/security-requirements`)
            .fetch<IGetTwoFAConfigurationResp>();
    }

    public async postTwoFAConfiguration(payload: IPostTwoFAConfigPayload) {
        return await this._httpClient
            .build(`${this._agencyUrl}/configure2fa`)
            .useMethod("POST")
            .useBody(payload)
            .fetch<IPostTwoFAConfigResp>();
    }
}

export interface IGetTwoFAConfigurationResp {
    IsEnabled: boolean;
    AllowedTypes: number[];
    IsSuccessful: boolean;
    Message?: string;
}

export interface IPostTwoFAConfigPayload {
    IsEnabled: boolean;
    AllowedTypes: number[];
    OrganizationId: string;
}

export interface IPostTwoFAConfigResp {
    IsSuccessful: boolean;
    Message?: string;
}
